export default {
    attribute: {
        url: '',
        fit: 'fill',
        preview: false,
        autoRotate: false,
        noQuery: false,
        rotateDuration: 2,
        bgColor: 'rgba(0,0,0,0)',
        cptTableData: [{
            "name": "值",
            "value": "",
            "namekey": "value"
        }],
        zIndex:null,
        isPreview:false,
        opacity: 1,
    },
    cptDataForm: {
        // dataText: '[{"label":"选项1","value":"op1"},{"label":"选项2","value":"op2"},{"label":"选项3","value":"op3"}]',
        dataText: '{"url":""}',
        dataSource: 1,
        pollTime: 0,
        isCache: false,
    },
    interaction: {
        multi: false
    },
}